import {$$} from '@vue-macros/reactivity-transform/macros'
import {RestrictedEditReasonType} from '@toolify/client/src/modules/databases/enum/RestrictedEditReasonType'

export function useAutoIdPropertyTypeStrategy() {

  const getRestrictedEditReason = (): RestrictedEditReasonType | null => {
    return null
  }

  return $$({
    getRestrictedEditReason,
  })
}
